import React, {useState} from 'react';
import {useGetMovementProductsQuery} from '../../../redux/DepotSlice/depotReportApi';
import s from '../ProductReport.module.css';
import AddFilterButton from '../../../Components/Buttons/AddFilterButton';
import FilterProducts from '../../../Components/Filter/FilterProducts';
import styleTableGrid from '../../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import ProductTableRowEl from '../components/ProductTableRowEl';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';
import {monthNow, todayDate} from '../../../assets/utils/dateUtils';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {
	DataInDataMovementsType,
	RequestMovementType,
	ValuesMovementType,
} from '../../../types/StoreReportTypes';
import GridTableHead from '../../../Components/GridTableHead/GridTableHead';

const MovementProductsTable: React.FC = () => {
	const {t} = useTranslation();
	const [openFilter, setOpenFilter] = useState(false);

	const [filters, setFilters] = useState<RequestMovementType>({
		from_date: monthNow(),
		to_date: todayDate(),
		every_day: 0,
	});
	const [productList, setProductList] = useState<
		DataInDataMovementsType[] | null
	>(null);

	const [page, setPage] = useState(0); // текущая страница (0 = первая)
	const pageSize = 10;

	const {data, isLoading} = useGetMovementProductsQuery(filters);

	const handleSubmitFilters = (values: ValuesMovementType) => {
		const payload: RequestMovementType = {
			...values,
			every_day: values.every_day ? 1 : 0,
		};
		setFilters(payload);
		setOpenFilter(false);
		setProductList(null);
		setPage(0);
	};

	const columns = [
		'',
		t('Назва'),
		t('На початок'),
		t('Прихід'),
		t('Повернення'),
		t('Оформлення'),
		t('На кінець'),
	];

	const handleChangeDate = (data: DataInDataMovementsType[] | null) => {
		setProductList(data);
		setPage(0); // сбрасываем при смене даты
	};

	const start = page * pageSize;
	const end = start + pageSize;
	const visibleProducts = productList?.slice(start, end) ?? [];

	const hasPrev = page > 0;
	const hasNext = productList ? end < productList.length : false;

	return (
		<>
			<div className={s.table}>
				<div className={s.title}>{t('Таблиця товарів')}</div>
			</div>
			<div className={s.productsTable}>
				<div className={s.filterButton}>
					<AddFilterButton
						color={'blue'}
						setFilterMenu={setOpenFilter}
						filterMenu={openFilter}
					/>
				</div>
				<FilterProducts
					active={openFilter}
					handleSubmit={handleSubmitFilters}
				/>
				<ul className={s.datePagination}>
					{data?.dates.map((date, index) => (
						<li key={date.date + index} className={s.datePaginationElement}>
							<button onClick={() => handleChangeDate(date.data)}>
								{date.date}
							</button>
						</li>
					))}
				</ul>
			<div className={s.productTable}>
				{isLoading ? (
					<PreLoaderComponent type={'circle'} size={'big'} />
				) : (
					productList && (
						<div className={s.tableWrapper}>
							<div className={styleTableGrid.tableGrid}>
								<GridTableHead
									columns={columns}
									gridTemplateColumns={'1fr 2fr repeat(5, 1fr)'}
									customClassName={styleTableGrid.tableRow}
								/>

								{visibleProducts.map((product) => (
									<ProductTableRowEl
										product={product}
										key={product.product_id}
									/>
								))}

								<div className={s.buttonWrapper}>
									{hasPrev && (
										<LightGreenButton
											type={'button'}
											text={t('Назад')}
											onClick={() => setPage((p) => p - 1)}
										/>
									)}
									{hasNext && (
										<LightGreenButton
											type={'button'}
											text={t('Далі')}
											onClick={() => setPage((p) => p + 1)}
										/>
									)}
								</div>
							</div>
						</div>
					)
				)}
			</div>
			</div>
		</>
	);
};

export default MovementProductsTable;
